import React, { Component } from "react";
import BackIcon from "../../../assets/images/MobileApp/back.svg";
import LeftIcon from "../../../assets/images/MobileApp/logout.svg";
import "./sampleMobileApp.css";
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { ToggleChange } from '../../../redux/action/Header';
import { signOut } from '../../../redux/action/main';

class MobileHeader extends Component{
    constructor(props) {
        super(props);
        this.state = {
        };
        this.logOut = this.logOut.bind(this)
    }

    logOut() {
            localStorage.removeItem("authToken");
            localStorage.clear();
            this.props.signOut();
            // this.props.history !== undefined && this.props.history.push("/")
            this.props.history !== undefined && this.props.history.replace("/");  //This ensures that the user cannot go back after logging out. clear route history stack
        }

    render(){
        return(
                           <div class="container1">
                           
                            <button className="backbutton" onClick={() => {
                                const route = this.props.history.location.state && this.props.history.location.state.route
                                route !== undefined ? this.props.history.push(`/${route}`, {
                                    [`${route.toLowerCase()}`]: {
                                        ...this.props.history.location.state[`${route.toLowerCase()}`]
                                    }
                                }) : this.props.history.goBack()
                            }}>
                                
                               <img src={BackIcon} alt="back" className="backicon" />
                            </button>
                            <span className="title1" >Sample Request</span>
                            <button className="button1"> <div className="logoutdiv" onClick={() => this.logOut()}> <img src={LeftIcon} alt="logout" className="logouticon"/></div> 
                            </button>
                            </div>
        )
    }
}


// const mapStateToProps = (state) => {
//     return ({
//         toggle: state.Header.toggle,
//         userDetails : state.main
//     });
// }

const mapDispatchToProps = (dispatch) => {

        // options.filter((data) => data.moduleName == this.props.location.moduleName)

    return bindActionCreators({
        "signOut" : signOut
    }, dispatch)
}


export default withRouter(connect(null,mapDispatchToProps)(MobileHeader));



// WEBPACK FOOTER //
// ./src/pages/Sample/SampleMobileApp/MobileHeader.js